import { Play, Pause } from 'lucide-react';
import { IconButton } from './IconButton';

interface PlayButtonProps {
  isPlaying: boolean;
  onPlay: () => void;
  onPause: () => void;
}

export function PlayButton({ isPlaying, onPlay, onPause }: PlayButtonProps) {
  return (
    <IconButton 
      onClick={isPlaying ? onPause : onPlay} 
      title={isPlaying ? 'Pause' : 'Play'}
    >
      {isPlaying ? <Pause size={20} /> : <Play size={20} />}
    </IconButton>
  );
}